import React from "react";
import { useRouter } from "next/router";
import RegistrationForm from "../RegistrationForm";

const DesktopSignUp = ({
  formFields,
  options,
  responseSocial,
  dispatcher,
  onChangeDropdown,
  onChange,
  buttonClicked,
  countryCode,
}) => {
  const router = useRouter();
  return (
    <div className=" flex flex-row xs:hidden">
      <div className={`sm:w-1/2 custom1:w-full lg:w-3/5 bg-white pt-24`}>
        <RegistrationForm
          formFields={formFields}
          dispatcher={dispatcher}
          responseSocial={responseSocial}
          countryCode={countryCode}
          options={options}
          onChangeDropdown={onChangeDropdown}
          buttonClicked={buttonClicked}
          onChange={onChange}
        />
      </div>
      <div
        onClick={() => router.push("/")}
        className="bg-Body flex flex-col cursor-pointer justify-center items-center custom1:hidden sm:w-1/2 lg:w-2/5"
      >
        {process.env.NEXT_PUBLIC_THEME === "LT" ? (
          <>
            <img src={"/Images/bigTruck.webp"} width={500} />
            <div className="flex items-center justify-center">
              <img
                width={"100px"}
                className="rounded-full mt-3"
                src="/Images/logo-circle.webp"
              />
              <img
                src="/Images/wordmark-luckytruck.webp"
                style={{ width: "65%" }}
              />
            </div>
          </>
        ) : (
          <>
            <img src={"/Images/flexport/bigTruck.webp"} />
            <img width={"300px"} src="/Images/flexport/Logo-flexport.webp" />
          </>
        )}
      </div>
    </div>
  );
};

DesktopSignUp.displayName = "DesktopSignUp";
export default DesktopSignUp;
